import { LimitedAccessPage } from './LimitedAccessPage';

export default LimitedAccessPage;